import {DealParent, isBar, isChain} from "../../interfaces/IMomentDeal";
import {doc, Timestamp, updateDoc} from "@firebase/firestore";
import {getBarsOfChain} from "../tools/getBarWithDeals";
import {db} from "../../firebase/config";

export async function markFresh(dealParent: DealParent) {
    console.log("Marking as fresh ", dealParent)
    async function updateBar(id: string) {
        await updateDoc(doc(db, "bars", id), {
            updated_at: Timestamp.now()
        })
    }
    if (isBar(dealParent)) {
        await updateBar(dealParent.id)
    } else if (isChain(dealParent)) {
        await updateDoc(doc(db, "chains", dealParent.id), {
            updated_at: Timestamp.now()
        })
        const bars = await getBarsOfChain(dealParent)
        for (const bar of bars) {
            await updateBar(bar.id)
        }
    }
    console.log("Done marking as fresh ", dealParent)
}